import { useMutation, useQueryClient } from "@tanstack/react-query";

import { showToast } from "../../../utils/toast";
import { updateProject } from "../api";
import { useAppSelector } from "store";
import { selectAuthUser } from "store/slices/auth/auth.selector";
import toast from "react-hot-toast";

export const useUpdateProjectMutation=()=>{
    const queryClient = useQueryClient();
  const user = useAppSelector(selectAuthUser);
   return useMutation({
        mutationFn: updateProject,
    
        onError: (error: any) => {
          if (error.isBusinessError) {
            
            toast.error(error.message); // "Project Name already exists"
            return;
          }
    
          if (error.isNetworkError) {
            toast.error("Network error. Please try again.");
            return;
          }
    
          toast.error("Something went wrong");
        },
    
        onSuccess: (_data, variables) => {
          // Refetch the projects list
          queryClient.invalidateQueries({
            queryKey: ["projects", user?.appUserUuid],
          });

          // Invalidate the specific project and its defaults (including member list)
          if (variables?.projectUuid) {
            queryClient.invalidateQueries({
              queryKey: ["project", variables.projectUuid],
            });
            queryClient.invalidateQueries({
              queryKey: ["project-default", variables.projectUuid],
            });
          }

          toast.success("Project updated successfully");
        },
      })
    }
